import wishlistReducer from './generalReducer';

export * from './generalActions';
export default wishlistReducer;
